import { atom } from 'jotai';

import { WidgetCurrency } from './api/types';

type WidgetCurrencyState = {
  widgetCurrencies: WidgetCurrency[];
  widgetCurrency: WidgetCurrency;
};

export const defaultCurrency = { name: 'Euro', code: 'EUR', symbol: '€' };

export const widgetCurrencyAtom = atom<WidgetCurrencyState>({
  widgetCurrencies: [],
  widgetCurrency: defaultCurrency
});
